import { getRegisterFunction } from '../../utils/register.js';
import { OneUxButtonElement } from './OneUxButtonElement.js';
export const register = getRegisterFunction(OneUxButtonElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-button': OneUxButtonElement;
    "button-44d28ca764208048cfd0b1cc2f6ae1e1": OneUxButtonElement;
  }
}